import "./Content.css"
import Rocky from "./Rocky.svg"
import MasterRo from "./MasterRo.svg"
import { Button } from './Button'

export const Content = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const mode = queryParams.get("mode")

  return (
    <div className="Content">
      <div className="Content_Header">
        <div className="Content_Header_Inner">
          <div className="Content_Header_Rim">
            <h1>Download Notero Piano Adventure</h1>
          </div>
        </div>
      </div>

      <div className="Content_Body">
        <div className="Content_Inner">
          <p>
            Notero Piano Adventure provides a high quality experience gamification piano class platform for an enjoyable <br />moment of learning and practicing.
          </p>

          <div className="Content_Download_Section">
            <div className="Content_Download Instructor">
              <img src={MasterRo} alt="MasterRoTheInstructor" />
              <h3>Download Piano Adventure</h3>
              <span className='Content_Download_Description'>For use as a standalone application <br />or as an instructor device in Classroom mode.</span>
              <a href="https://s3.ap-southeast-1.amazonaws.com/download.notero.co/store/npa/builds/windows/NoteroPianoAdventure_Installer_v3.3.0.exe">
                <Button className="Button-Download">DOWNLOAD APP</Button>
              </a>
              <div className='Content_Download_Hint'>For Windows 7, 10, 11</div>
            </div>

            {mode != null && mode == 'full' && (
              <>
                <p className="notice">
                  You can play Piano Adventure on multiple devices simultaneously in Classroom mode, <br />which requires both an instructor device and a student device.
                </p>

                <div className="Content_Download Student">
                  <div className='Content_Download_Rocky'>
                    <img src={Rocky} alt="RockyTheStudent" />
                    <img src={Rocky} alt="RockyTheStudent" />
                    <img src={Rocky} alt="RockyTheStudent" />
                  </div>
                  <h3>Only For Classroom mode</h3>
                  <span className='Content_Download_Description'>You need to have the instructor device <br />before you can play the student device and Classroom mode.</span>
                  <a href="https://s3.ap-southeast-1.amazonaws.com/download.notero.co/store/npa/builds/android/NoteroPianoAdventure_Installer_v3.3.0.apk">
                    <Button className="Button-Download">FOR STUDENT DEVICE</Button>
                  </a>
                  <div className='Content_Download_Hint'>For Android version 10 or higher.</div>
                </div>
              </>
            )}
          </div>

        </div>
      </div>
    </div>
  )
}
